import { Notify, type QNotifyCreateOptions } from 'quasar';
import {
  NEGATIVE_NOTIFICATION_PROPS,
  POSITIVE_NOTIFICATION_PROPS,
  PRIMARY_NOTIFICATION_PROPS,
  WARNING_NOTIFICATION_PROPS
} from 'src/constants/notification';

function createNotification(
  defaultProps: QNotifyCreateOptions,
  message: string,
  additionalProps: QNotifyCreateOptions = {}
) {
  return Notify.create({
    ...defaultProps,
    message,
    ...additionalProps
  });
}

export function displayErrorMessage(message: string, additionalProps: QNotifyCreateOptions = {}) {
  return createNotification(NEGATIVE_NOTIFICATION_PROPS, message, additionalProps);
}

export function displaySuccessMessage(message: string, additionalProps: QNotifyCreateOptions = {}) {
  return createNotification(POSITIVE_NOTIFICATION_PROPS, message, additionalProps);
}

export function displayWarningMessage(message: string, additionalProps: QNotifyCreateOptions = {}) {
  return createNotification(WARNING_NOTIFICATION_PROPS, message, additionalProps);
}

export function displayInfoMessage(message: string, additionalProps: QNotifyCreateOptions = {}) {
  return createNotification(PRIMARY_NOTIFICATION_PROPS, message, additionalProps);
}

export function useNotify() {
  return {
    displayErrorMessage,
    displaySuccessMessage,
    displayWarningMessage,
    displayInfoMessage
  };
}
